import React, { useState, useEffect, useRef } from 'react';

// Define the sequence: two heartbeats (alternating phrases)
const words = ['YOUR TECH', 'YOUR WAY', 'YOUR TECH', 'YOUR WAY'];

const TextSequence = ({ onComplete }) => {
  const [segmentIndex, setSegmentIndex] = useState(0);
  const audioRef = useRef(null);

  // Preload the thump sound
  useEffect(() => {
    audioRef.current = new Audio('/sounds/thump.mp3');
    audioRef.current.volume = 1.0;
    audioRef.current.load();
  }, []);

  // Play the thump sound when the segment changes
  useEffect(() => {
    if (segmentIndex < words.length) {
      const audio = audioRef.current;
      if (audio) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
      }
    }
  }, [segmentIndex]);

  // Manage heartbeat timing
  useEffect(() => {
    let timer;
    if (segmentIndex < words.length) {
      const isOdd = segmentIndex % 2 === 1;
      const delay = isOdd ? 1200 : 600; // Longer pause after "YOUR WAY"
      timer = setTimeout(() => {
        setSegmentIndex(segmentIndex + 1);
      }, delay);
    } else {
      onComplete(); // Trigger completion callback
    }
    return () => clearTimeout(timer);
  }, [segmentIndex, onComplete]);

  // Return null when sequence is complete
  if (segmentIndex >= words.length) {
    return null;
  }

  // Format text with heartbeat animation
  const formatText = (text) => {
    const tokens = text.split(' ');
    if (tokens[0] === 'YOUR' && tokens.length > 1) {
      const secondPart = tokens.slice(1).join(' ');
      return (
        <div key={segmentIndex} className="inline-table w-full table-fixed text-center">
          <div className="table-row">
            <div
              className="table-cell text-white text-[15vw] font-bold mb-[1vw] animate-heartbeat select-none caret-transparent"
            >
              YOUR
            </div>
          </div>
          <div className="table-row">
            <div
              className="table-cell text-[#3080C1] text-[15vw] font-bold mt-[1vw] animate-heartbeat select-none caret-transparent"
            >
              {secondPart}
            </div>
          </div>
        </div>
      );
    }
    return text;
  };

  return (
    <div className="w-full h-screen bg-black flex items-center justify-center font-[Metropolis]">
      <h1 className="m-0 w-[75vw] text-center select-none caret-transparent">
        {formatText(words[segmentIndex])}
      </h1>
    </div>
  );
};

export default TextSequence;